import { Controller } from '@hotwired/stimulus';

// お問い合わせフォームの非同期送信。
// - モーダル (#contactModal): フォームを隠しお礼を表示。失敗時はフォーム先頭にエラー。
// - フッターフォーム (.quick_form): 送信後にフォーム直後へ結果メッセージを挿入し 5 秒で消す。
export default class extends Controller {
  static targets = ['formWrap', 'thanks'];

  async submit(event) {
    event.preventDefault();

    // submit イベントを出したフォームを優先する。モーダル内には自己解決の導線
    // (button_to が生む form) が先に並ぶため、querySelector('form') では別の
    // フォームを掴んでしまう (#2681)。
    const form = (event.target instanceof HTMLFormElement && event.target)
      || (this.element.matches('form') ? this.element : this.element.querySelector('.contact-modal-form, form'));
    if (!form) { return; }

    let ok = false;
    let errors = [];
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      ok = response.ok;
      if (!ok) {
        const body = await response.json().catch(() => ({}));
        errors = Array.isArray(body.errors) ? body.errors : [];
      }
    } catch {
      ok = false;
    }

    if (this.isModal) {
      this.renderModalResult(form, ok, errors);
    } else {
      this.renderFooterResult(form, ok);
    }
  }

  // モーダル内かどうかで送信後の表示を切り替える。特定の id ではなく
  // .modal の有無で判定し、任意のお問い合わせ系モーダルで動くようにする。
  get isModal() {
    return this.element.classList.contains('modal') || this.element.closest('.modal') !== null;
  }

  renderModalResult(form, ok, errors = []) {
    const existingError = this.element.querySelector('#contact-modal-error');
    if (existingError) { existingError.remove(); }

    if (ok) {
      form.reset();
      if (this.hasFormWrapTarget) { this.formWrapTarget.classList.add('d-none'); }
      if (this.hasThanksTarget) { this.thanksTarget.classList.remove('d-none'); }
      return;
    }

    // 入力内容の不備は理由をそのまま出す。何を直せばよいか分かるようにするため。
    // サーバーの文言を innerHTML で流し込まないよう textContent で組み立てる。
    const alertEl = document.createElement('div');
    alertEl.className = 'alert alert-danger';
    alertEl.id = 'contact-modal-error';

    if (errors.length > 0) {
      const heading = document.createElement('strong');
      heading.textContent = '送信できませんでした。';
      alertEl.append(heading);

      const list = document.createElement('ul');
      list.className = 'mb-0 mt-1';
      errors.forEach((message) => {
        const item = document.createElement('li');
        item.textContent = message;
        list.append(item);
      });
      alertEl.append(list);
    } else {
      const heading = document.createElement('strong');
      heading.textContent = '送信に失敗しました。';
      alertEl.append(heading, document.createElement('br'));
      alertEl.append('お手数ですが、もう一度お試しください。');
    }

    form.prepend(alertEl);
  }

  renderFooterResult(form, ok) {
    form.reset();

    const id = ok ? 'contact-success-message' : 'contact-error-message';
    const existing = document.getElementById(id);
    if (existing) { existing.remove(); }

    const html = ok
      ? `<div class="alert alert-success mt-3" id="${id}">
           <strong>お問い合わせありがとうございました。</strong><br>
           担当者より折り返しご連絡を差し上げますので、しばらくお待ちください。<br>
           内容によっては、お時間をいただく場合や回答しかねる場合がございますので、あらかじめご了承ください。
         </div>`
      : `<div class="alert alert-danger mt-3" id="${id}">
           <strong>メールの送信に失敗しました。</strong><br>
           お手数ですが、もう一度お試しください。
         </div>`;

    form.insertAdjacentHTML('afterend', html);

    setTimeout(() => {
      const message = document.getElementById(id);
      if (message) {
        message.style.transition = 'opacity 0.5s';
        message.style.opacity = '0';
        setTimeout(() => message.remove(), 500);
      }
    }, 5000);
  }
}
